/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import { userService } from "../dependencyInjection";
import { User, PasswordData } from "../services/UserService";
import { RequestStatus } from "../../shared";
import { unsubscribe } from "../../../../utils";
import { useAuth } from "../../../auth";

type UseUserInfo = () => Promise<void>;
type UseSaveUserInfo = (userInfo: User, file?: File | Blob) => Promise<void>;
type UseChangePasswordUser = (passwordData: PasswordData) => Promise<void>;
type UseUserResult = [User, RequestStatus, UseSaveUserInfo, UseChangePasswordUser, UseUserInfo];

export function useUser(): UseUserResult {
  const [user, setUser] = useState(userService.user);
  const [status, setStatus] = useState(RequestStatus.None);
  const [isAuth] = useAuth();

  useEffect(() => {
    const subUser = userService.user$.subscribe((userInfo) => {
      setUser(userInfo);
    });
    const subStatus = userService.status$.subscribe((code) => {
      setStatus(code);
    });
    return unsubscribe(subUser, subStatus);
  }, []);

  const getUserInfo = useMemo(
    () => async () => {
      try {
        await userService.getUserInfo();
      } catch (e) {}
    },
    [],
  );

  const saveUserInfo = useMemo(
    () => async (userInfo: User, file?: File | Blob) => {
      try {
        await userService.saveUserInfo(userInfo, file);
      } catch (e) {}
    },
    [],
  );

  const changePasswordUser = useMemo(
    () => async (passwordData: PasswordData) => {
      try {
        await userService.changeUserPassword(passwordData);
      } catch (e) {}
    },
    [],
  );

  useEffect(() => {
    if (isAuth) {
      getUserInfo();
    }
  }, []);

  return [user, status, saveUserInfo, changePasswordUser, getUserInfo];
}
